module.exports = __webpack_public_path__ + "static/media/OrdemServico5.67d504a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancOrdemServicos/OrdemServico5.png
// module id = 1769
// module chunks = 0